/** Full-screen brand mark shown while Clerk restores the session. */
export function AuthLoading() {
  return (
    <div
      role="status"
      aria-label="Loading"
      style={{
        display: "grid",
        minHeight: "100dvh",
        placeItems: "center",
        background: "#fbf8f3",
      }}
    >
      <span
        style={{
          display: "grid",
          width: "2.75rem",
          height: "2.75rem",
          placeItems: "center",
          border: "1px solid #c9a96e",
          borderRadius: "50%",
          color: "#702f3a",
          fontFamily: "var(--font-family-heading), Georgia, serif",
          fontSize: "1.2rem",
        }}
      >
        A
      </span>
    </div>
  );
}
